import { ApiService } from "../../../constants/ApiService";
import { HttpService } from "../../../constants/HTTPService";
import { NewIDataUploadItem } from "../../../interfaces/IDataUploadItem";
import { IForm } from "../../../interfaces/IForm";
import { RequestType } from "../../../shared/Enum";

export const getUserTesting = async () => {
  const data = HttpService.get(ApiService.testing.getTestingUser);
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getListRequestType = async () => {
  const data = HttpService.get(ApiService.alesaForm.getListRequestType);
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getListDocumentType = async () => {
  const data = HttpService.get(ApiService.alesaForm.getListDocumentType);
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getListAreaLocation = async () => {
  const data = HttpService.post(
    ApiService.apiHc.getAreaLocation,
    JSON.stringify({
      AreaLocation: { LocationID: "", LocationHierarcyID: "" },
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

interface EditFormLrDto {
  dataForm?: IForm;
  dataUpload?: NewIDataUploadItem[];
  uploadRealization?: NewIDataUploadItem[];
  requestID?: string;
  requestStatusID?: string;
  dataUploadSK?: NewIDataUploadItem[];
  isSend?: boolean;
  crrNumber?: string;
  emailType?: string;
  noteRequestRevise?: string;
}

function convertData(inputData: NewIDataUploadItem[]) {
  return inputData.reduce((acc: any[], curr) => {
    const files = curr.files.map((file) => ({
      title: curr.title,
      fileType: curr.fileType,
      ...file,
    }));
    return [...acc, ...files];
  }, []);
}

export const editFormLR = async (payload: EditFormLrDto) => {
  const files = convertData(payload.dataUpload || []);
  const realization =
    payload?.dataForm?.needRealization == "true"
      ? convertData(payload.uploadRealization || [])
      : [];
  const sk = convertData(payload.dataUploadSK || []);

  const data = HttpService.post(
    ApiService.alesaForm.editFormLegalRelationship,
    JSON.stringify({
      CrrNumber: payload.crrNumber,
      StartDateString: payload.dataForm?.startDatePeriod,
      EndDateString: payload.dataForm?.endDatePeriod,
      RequestDate: payload.dataForm?.requestDate,
      POADate: payload.dataForm?.dateOfPower,
      POAGrantDate: payload.dataForm?.dateGrantOfPower,
      CLNote: payload.dataForm?.clNote,
      LRNote: payload.dataForm?.lrNote,
      BinusianID: payload.dataForm?.binusianID,
      BinusianName: payload.dataForm?.binusianName,
      TitleAgreement: payload.dataForm?.titleAgreement,
      Counterpart: payload.dataForm?.counterPart,
      Signer: `${payload.dataForm?.signer?.binusianIDEmail}#${payload.dataForm?.signer?.name}`,
      NeedSK:
        payload.dataForm?.requestType ==
        RequestType.toId(RequestType.DokumenMaster)
          ? payload.dataForm?.needSK == "true"
          : null,
      NeedRealization:
        payload.dataForm?.requestType ==
        RequestType.toId(RequestType.DokumenMaster)
          ? payload.dataForm?.needRealization == "true"
          : null,
      DocumentTypeID: payload.dataForm?.documentType,
      Area: payload.dataForm?.area,
      DetailArea: payload.dataForm?.address,
      ListDocument: files,
      RequestID: payload.requestID,
      RequestTypeID: payload.dataForm?.requestType,
      Delegatee:
        payload.dataForm?.delegatee != null
          ? `${payload.dataForm?.delegatee?.binusianIDEmail}#${payload.dataForm?.delegatee?.name}`
          : payload.dataForm?.delegatee,
      Substitutor:
        payload.dataForm?.substitutor != null
          ? `${payload.dataForm?.substitutor?.binusianIDEmail}#${payload.dataForm?.substitutor?.name}`
          : payload.dataForm?.substitutor,
      NoPowerAttorney: payload.dataForm?.noPowerAttorney,
      NoSubstitutor: payload.dataForm?.noSubstitutor,
      RequestStatusID: payload.requestStatusID,
      IsSend: payload.isSend,
      ListFileUploadDocumentHardCopySK: sk,
      ListFileUploadDocumentRealization: realization,
      EmailType: payload.emailType,
      RevisionNote: payload.noteRequestRevise,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI;
};

export const getSingleDataRequest = async (requestID?: string) => {
  const data = HttpService.post(
    ApiService.alesaForm.getSingleDataRequest,
    JSON.stringify({
      RequestID: requestID,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const downloadSingleFile = async (
  documentName?: string,
  category?: string,
  requestID?: string,
  sharepointToken?: string
) => {
  const data = HttpService.post(
    ApiService.alesaForm.downloadSingleFile,
    JSON.stringify({
      DocumentName: documentName,
      Category: category,
      RequestID: requestID,
      SharepointToken: sharepointToken,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getSharepointToken = async () => {
  const data = HttpService.get(ApiService.alesaForm.getSharepointToken);
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const sendBack = async (
  requestID?: string,
  binusianID?: string,
  comment?: string,
  commentDocument?: NewIDataUploadItem[],
  requestStatusID?: string
) => {
  const files = convertData(commentDocument || []);

  const data = HttpService.post(
    ApiService.alesaForm.sendBackFromLegalRelationship,
    JSON.stringify({
      RequestID: requestID,
      BinusianID: binusianID,
      Comment: comment,
      ListCommentDocument: files,
      RequestStatusID: requestStatusID,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI;
};

export const downloadFileComment = async (
  commentID?: string,
  requestID?: string,
  sharepointToken?: string
) => {
  const data = HttpService.post(
    ApiService.alesaForm.downloadFileComment,
    JSON.stringify({
      CommentID: commentID,
      RequestID: requestID,
      SharepointToken: sharepointToken,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const resendEmailFinishedForm = async (
  requestID?: string,
  emailType?: string
) => {
  const data = HttpService.post(
    ApiService.alesaForm.resendEmailFinishedForm,
    JSON.stringify({
      RequestID: requestID,
      EmailType: emailType,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI;
};
